const config = {
  state: {
    abiertos : {
      solicitud_de_insumo             : 0,
      incidencia_con_equipo             : 0,
      all_usuario_o_cliente: 0,
      garantia_sin_atencion: 0,
      garantia_sin_asignar : 0,
      garantia_campo       : 0,
      garantia_taller      : 0
    }
  },
  mutations: {
    SET_CONTADORES (state, aux) {
      state.abiertos.solicitud_de_insumo              = aux.solicitud_de_insumo || 0
      state.abiertos.incidencia_con_equipo              = aux.incidencia_con_equipo || 0
      state.abiertos.all_usuario_o_cliente = aux.all_usuario_o_cliente || 0
      state.abiertos.garantia_campo        = aux.garantia_campo || 0
      state.abiertos.garantia_taller       = aux.garantia_taller || 0
      state.abiertos.garantia_sin_asignar  = aux.garantia_sin_asignar || 0
      state.abiertos.garantia_sin_atencion = aux.garantia_sin_atencion || 0
    }
  },
  actions: {
    setContadores ({ commit }, payload) {
      commit('SET_CONTADORES', payload)
    }
  },
  getters : {
  }
}

export default config



// WEBPACK FOOTER //
// ./src/store/ticket.js